import AssessmentResultsDashboard from "../../../assessment/[assessment_id]/results/AssessmentResults";

export default AssessmentResultsDashboard;